"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const AlignLeft = (props) => React.createElement("svg", { className: "lucide lucide-align-left", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M15 12H3M17 18H3M21 6H3" }));
exports.default = AlignLeft;
